class GlobalSearchManagerController {
	static $inject = ['mx.shell.SearchProviderService', 'mx.shell.NavigationService'];

	constructor(searchService, navigationService) {
		this.searchService = searchService;
		this.navigationService = navigationService;
	}

	$onInit() {
		this.getNavigationItems(this.navigationItemIds).then((navigationItems) => {
			this.searchService.showUnifiedSearch(navigationItems);
		});
	}

	$onDestroy() {
		this.searchService.hideUnifiedSearch();
	}

	async getNavigationItems(navigationItemIds) {
		const { navigationService } = this;
		const navigationItems = [];

		if (Array.isArray(navigationItemIds)) {
			for (let id of navigationItemIds) {
				const navigationItem = await navigationService.getNavigationItem(id);
				if (navigationItem) {
					navigationItems.push(navigationItem);
				}
			}
		}
		return navigationItems;
	}
}

export const mxGlobalSearchManagerComponent = {
	controller: GlobalSearchManagerController,
	controllerAs: 'vm',
	bindings: {
		navigationItemIds: '<navigationItems',
	},
	template: '',
};

angular.module('mx.shell').component('mxGlobalSearchManager', mxGlobalSearchManagerComponent);
